import React from 'react';
import PropTypes from 'prop-types';

import Businesses from './businesses';
import ContactInfo from './contact_info';
import Email from './email';
import ManagedFormGroup from 'components/form/managed_input/form_group';

export default class PersonForm extends React.Component {
  static propTypes = {
    allowSavingPrivateContacts: PropTypes.bool,
    contact: PropTypes.shape({
      addresses: PropTypes.array.isRequired,
      email: PropTypes.string,
      firstName: PropTypes.string,
      jobTitle: PropTypes.string,
      middleName: PropTypes.string,
      lastName: PropTypes.string,
      phoneNumbers: PropTypes.array.isRequired,
    }),
    extraSections: PropTypes.node,
    multipleBusinesses: PropTypes.bool,
    onChange: PropTypes.func.isRequired
  }

  render() {
    return (
      <div className="form-horizontal">
        {this.renderPersonalInfo()}
        {this.renderContactInfo()}
        {this.renderProfessionalInfo()}
        {this.props.extraSections}
      </div>
    );
  }

  renderPersonalInfo() {
    return <React.Fragment>
      <h3 className="mt-0">Name</h3>
      {this.renderFormGroup('firstName', 'First name', { placeholder: 'Type first name' })}
      {this.renderFormGroup('middleName', 'Middle name', { placeholder: 'Type middle name' })}
      {this.renderFormGroup('lastName', 'Last name', { placeholder: 'Type last name' })}
    </React.Fragment>;
  }

  renderContactInfo() {
    return <React.Fragment>
      <h3>Contact information</h3>

      <Email
        contact={this.props.contact}
        onChange={this.props.onChange}
      />

      <ContactInfo
        addresses={this.props.contact.addresses}
        phoneNumberLabels={['Work', 'Mobile', 'Fax']}
        phoneNumbers={this.props.contact.phoneNumbers}
        onChange={this.props.onChange}
      />
    </React.Fragment>;
  }

  renderProfessionalInfo() {
    return <React.Fragment>
      <h3>Professional information</h3>
      {this.renderFormGroup('jobTitle', 'Job title', { placeholder: 'Type exact job title' })}
      {this.renderFormGroup('licenseNumber', 'License Number', { placeholder: 'Type license number if applicable' })}
      <Businesses
        allowSavingPrivateContacts={this.props.allowSavingPrivateContacts}
        contact={this.props.contact}
        multipleBusinesses={this.props.multipleBusinesses}
        onChange={this.props.onChange}
      />
    </React.Fragment>;
  }

  renderFormGroup(name, label, props = {}) {
    return (
      <ManagedFormGroup
        autoComplete="off"
        label={label}
        name={name}
        value={this.props.contact[name]}
        onChange={this.props.onChange}
        {...props}
      />
    );
  }
}
